module.exports = __webpack_public_path__ + "static/media/goodrx.ddd72b36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/goodrx.svg
// module id = 25
// module chunks = 0